import API from 'app/utils/apiClient';
import { SECTION_TYPES } from 'app/utils/constants';
import { toParams } from 'app/utils/url';

const getSections = (type) => {
  const params = toParams({
    type,
    storyType: 'bloom',
    // storyType: type === SECTION_TYPES.ORIGINAL ? 'original' : 'standard',
  });

  return API.get(`/sections/?${params}`);
};

const getSectionBanners = (sectionId) =>
  API.get(`/sections/${sectionId}/banners/`);

const getStoriesBySection = (id, page = 1, perPage = 20) => {
  const params = toParams({
    page,
    perPage,
  });
  return API.get(`/sections/${id}/stories/?${params}`);
};

const getUsersBySection = (id, page = 1, perPage = 20) => {
  const params = toParams({
    page,
    perPage,
  });
  return API.get(`/sections/${id}/users/?${params}`);
};

export default {
  getSections,
  getSectionBanners,
  getStoriesBySection,
  getUsersBySection,
};



// WEBPACK FOOTER //
// ./src/app/apis/section.js